/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ActionFilter } from './ActionFilter';
import type { PagingAndSortingRequestParam } from './PagingAndSortingRequestParam';

export type ActionFilterDto = {
    exposeType?: ActionFilterDto.exposeType;
    actionFilter?: ActionFilter;
    pagingAndSortingRequestParam?: PagingAndSortingRequestParam;
}

export namespace ActionFilterDto {

    export enum exposeType {
        EXCEL = 'EXCEL',
        PDF = 'PDF',
        WORD = 'WORD',
        HTML = 'HTML',
        XML = 'XML',
        JSON = 'JSON',
        CSV = 'CSV',
    }


}
